/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {
    H1,
    Container,
    Item,
    LinkRoute,
    LinkButton,
} from './style';
import { TYPE_ENUM } from '../../../services/enums/sites/navItemsEnum';

const SitesContainerWithLinks = ({
    siteHeader,
    links,
    children,
}) => {
	const RenderLink = link => (
		<LinkRoute
			exact={link.exact}
			to={link.path}
			activeClassName="is-active"
		>
			{link.name}
		</LinkRoute>
	);
	const RenderButton = link => (
		<LinkButton
			onClick={link.action}
		>
			{link.name}
		</LinkButton>
	);
	return (
		<div
			className="row"
			style={{
				marginBottom: '1px',
				padding: '32px',
				paddingLeft: '64px',
				marginLeft: '0px',
				marginRight: '0px',
			}}
		>
			<div style={{ width: '100%' }}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						marginBottom: '18px',
					}}
				>
					<H1>
						{siteHeader}
					</H1>
					<Container>
						{links && links.map(link => (
							<Item>
								{link.type === TYPE_ENUM.link && RenderLink(link)}
								{link.type === TYPE_ENUM.action && RenderButton(link)}
							</Item>
					))}
					</Container>
				</div>
				{children}
			</div>
		</div>
	);
};

PropTypes.SitesContainerWithLinks = {
    siteHeader: PropTypes.string,
    links: PropTypes.array, 
    children: PropTypes.element,
};

export default SitesContainerWithLinks;
